import React from "react";
import "./EStat.scss";
import { EBadge } from "../EBadge/EBadge";
import { CommaSeparator } from "../../../data-access/utility";
import { TbArrowDownSquare } from "react-icons/tb";
import { BsDownload } from "react-icons/bs";
import { Menu, Loader } from "@mantine/core";
import { EButton } from "../Button/EButton";

interface IProps {
  iconSrc?: string;
  stat: number;
  label: string;
  text?: string;
  hideDownload?: boolean;
  hideStats?: boolean;
  loading?: boolean;
  onBaselineDownload?: () => void;
  onConsolidatedDownload?: () => void;
  onFollowupDownload?: () => void;
}

interface IStatsDownloadButton {
  onBaselineDownload?: () => void
  onConsolidatedDownload?: () => void
  onFollowupDownload?: () => void
  variant?: "outline" | "primary"
}

export function EStatsDownloadButton({ onBaselineDownload, onConsolidatedDownload, onFollowupDownload, variant = "outline" }: IStatsDownloadButton) {
  return (
    <Menu shadow="md" width={160} position="bottom-end" radius="md">
      <Menu.Target>
        <div
          className={`group flex gap-2 items-center text-slate-700  cursor-pointer bg-white/40 hover:bg-white/80 border border-white/60 rounded-md px-3 py-1.5 transition-all duration-200 shadow-sm backdrop-blur-sm ${variant === "outline" ? "border-blue-100 hover:text-blue-700" : "btn--primary"}`}>
          <BsDownload size={15} className="group-hover:-translate-y-0.5 transition-transform duration-200" />
          <span className="text-sm font-semibold">Download</span>
        </div>
      </Menu.Target>
      <Menu.Dropdown className="p-1.5">
        <Menu.Item
          onClick={() => { onBaselineDownload && onBaselineDownload() }}
          className="group rounded-md hover:bg-slate-50 p-2"
        >
          <div className="flex justify-between items-center gap-2 group-hover:text-blue-500 text-slate-700 font-medium text-sm">
            <span>Baseline</span>
            <BsDownload size={14} className="text-slate-400 group-hover:text-blue-500 transition-colors" />
          </div>
        </Menu.Item>
        <Menu.Item
          onClick={() => { onFollowupDownload && onFollowupDownload() }}
          className="group rounded-md hover:bg-slate-50 p-2"
        >
          <div className="flex justify-between items-center gap-2 group-hover:text-blue-500 text-slate-700 font-medium text-sm">
            <span>Followup</span>
            <BsDownload size={14} className="text-slate-400 group-hover:text-blue-500 transition-colors" />
          </div>
        </Menu.Item>
        <Menu.Item
          onClick={() => { onConsolidatedDownload && onConsolidatedDownload() }}
          className="group rounded-md hover:bg-slate-50 p-2"
        >
          <div className="flex justify-between items-center gap-2 group-hover:text-blue-500 text-slate-700 font-medium text-sm">
            <span>Consolidated</span>
            <BsDownload size={14} className="text-slate-400 group-hover:text-blue-500 transition-colors" />
          </div>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export function EStat({ iconSrc, stat, label, text, hideDownload, hideStats, loading, onBaselineDownload, onConsolidatedDownload, onFollowupDownload }: IProps) {
  return (
    <div className={`stat-container group ${onBaselineDownload && `cursor-pointer`}`}
      onClick={() => {
        onBaselineDownload && onBaselineDownload();
      }}
    >
      {!hideStats && (
        <div className="flex gap-4 items-center flex-1">
          <div className="icon px-2">
            {iconSrc ? (
              <img src={iconSrc} alt={label} />
            ) : (
              <p className="px-2">{text}</p>
            )}
          </div>
          <div className="stat-info flex flex-col justify-center">
            <div className="stat">{CommaSeparator(stat ?? 0)}</div>
            <div className="label line-clamp-1" title={label}>{label}</div>
          </div>
        </div>
      )}
      {!hideDownload && (
        <div className="ml-2 z-10 flex items-center justify-center">
          {loading ? (
            <Loader size="xs" color="gray" />
          ) : (
            <BsDownload className="" />
          )}
        </div>
      )}
    </div>
  );
}
